import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import './../../styles/admin/NavbarTop.css';
import Logo from './../../components/logo.png'
import LogoMobile from './../../components/logo-mobile.png'
import * as globals from './../../components/GlobalScripts.js';

const NavbarTop = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState([]);
    const [isMenuOpen, setMenuIsOpen] = useState(false);

    useEffect(() => {
        if (globals.isAuthenticated()) {
            globals.validateSession();
        }
        setMenuIsOpen(false);
    }, [location]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }
    }, []);

    const toggleMenuDropdown = () => {
        setMenuIsOpen(!isMenuOpen);
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        localStorage.removeItem('session_id');
        localStorage.removeItem('keylogin');
        localStorage.removeItem('code_confirm');
        localStorage.removeItem('user');

        navigate(`/login`);
    };

    return (
        <>
            <nav className="navbar-top mobile">
                <div className="navs">
                    <div className="primary-nav-mobile">
                        <div>
                            <Link to="/">
                                <img className='logo square' src={LogoMobile} alt='Logo' />
                            </Link>
                        </div>
                        <div>
                            <button onClick={toggleMenuDropdown} className="container-icon cursor-pointer">
                                {!isMenuOpen ? (
                                    <svg viewBox="0 0 33 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1H23" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M10 13H32" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 34 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L33 20" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1.5 20L33 1" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                    </svg>

                                )}
                            </button>
                        </div>
                    </div>

                    {isMenuOpen && (
                        <div className="secundary-nav">
                            <div>
                                <NavLink to="/chat/view" className="button-primary transparent" onClick={toggleMenuDropdown}>Conversaciones</NavLink>
                                <NavLink to="/admin/cuentas" className="button-primary transparent" onClick={toggleMenuDropdown}>Cuentas</NavLink>
                                <NavLink to="/admin/mensajes" className="button-primary transparent" onClick={toggleMenuDropdown}>Mensajes</NavLink>
                                <NavLink to="/admin/reviews" className="button-primary transparent" onClick={toggleMenuDropdown}>Reseñas</NavLink>
                                <NavLink to="/admin/pagos-de-clientes" className="button-primary transparent" onClick={toggleMenuDropdown}>Pagos de clientes</NavLink>
                                {/* <NavLink to="/admin/pagos-a-profesionales" className="button-primary transparent" onClick={toggleMenuDropdown}>Pagos a profesionales</NavLink> */}
                                <NavLink to="/admin/reportes" className="button-primary transparent" onClick={toggleMenuDropdown}>Reportes</NavLink>
                                <NavLink to="/admin/categorias" className="button-primary transparent" onClick={toggleMenuDropdown}>Categorias</NavLink>
                                <button onClick={handleLogout} className="button-primary normal">Cerrar sesión</button>
                            </div>
                        </div>
                    )}
                </div>
            </nav>
        </>
    );
};

export default NavbarTop;